import React from 'react'
import PropTypes from 'prop-types'

const codeNameMapping = {
  active: {
    displayName: 'Active',
    styles: {
      color: 'var(--color-contrast-primary-400)',
      backgroundColor: 'var(--color-primary-400)'
    }
  },
  archived: {
    displayName: 'Archived',
    styles: {
      color: 'var(--color-contrast-neutral-400)',
      backgroundColor: 'var(--color-neutral-400)'
    }
  },
  finalized: {
    displayName: 'Finalized',
    styles: {
      color: 'var(--color-contrast-success-400)',
      backgroundColor: 'var(--color-success-400)'
    }
  }
}

export const ReportStatusBadge = ({
  codeName
}) => {
  const { displayName, styles } = codeNameMapping[codeName] || {
    ...codeNameMapping.archived,
    displayName: codeName
  }

  return (
    <div
      className='radius-md font-size-xs gap-2 items-center py-1 px-2 font-bold'
      style={{
        width: 'fit-content',
        ...styles
      }}
    >
      <div>{displayName}</div>
    </div>
  )
}

ReportStatusBadge.propTypes = {
  codeName: PropTypes.string
}

export default ReportStatusBadge
